import { Routes, Route } from "react-router-dom";
import StoreInvoiceListingPage from "@/pages/financial/store-invoice-listing";

export default function StoreInvoiceListingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoreInvoiceListingPage />} />
    </Routes>
  );
}
